@if (personalDeetsForm != null) {
  <div class="tab-wrapper">
    <form [formGroup]="personalDeetsForm">
      <div class="row">
        <div class="col-xl-6" *ngIf="authService.canRead('employee_personal_details_panel')">
          <div class="card" [ngClass]="{ 'expanded-card': cardExpanders['personalDetails'] }">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('personalDetails')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['personalDetails'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Personal Details</h3>
              <div class="row" *hasPermission="'employee_employment_type'">
                <div class="col-xl-8 col-lg-12" *ngIf="client && employmentTypes">
                  <label>Employment Type</label>
                  <div class="radio-group flex-wrap justify-content-between">
                    <div
                      *ngIf="
                        !(person | async).Id || f.EmploymentTypeId.value == employmentTypes.W2
                      ">
                      <input
                        type="radio"
                        id="radio-w2"
                        formControlName="EmploymentTypeId"
                        name="EmploymentTypeId"
                        [value]="employmentTypes.W2"
                        [attr.disabled]="(person | async).Id ? 'disabled' : null"
                        (change)="onEmploymentTypeChange()" />
                      <label
                        for="radio-w2"
                        title="A W-2 employee typically receives a regular wage, employee benefits and requires the employer to withhold and contribute to FICA (federal payroll) taxes from the employee's paycheck. If unsure, select W-2 employee."
                        ><span></span>W-2 Employee</label
                      >
                    </div>
                    <div
                      *ngIf="
                        !(person | async).Id || f.EmploymentTypeId.value == employmentTypes.M1099
                      ">
                      <input
                        type="radio"
                        id="radio-1099"
                        formControlName="EmploymentTypeId"
                        name="EmploymentTypeId"
                        [value]="employmentTypes.M1099"
                        [attr.disabled]="(person | async).Id || disable1099 ? 'disabled' : null"
                        (change)="onEmploymentTypeChange()" />
                      <label
                        for="radio-1099"
                        title="A 1099 worker is a contractor or business owner who receives pay in accord with the terms of a contract. Independent contractors cover their own employment taxes. If unsure, select W-2 employee."
                        ><span></span>1099</label
                      >
                    </div>
                    <div
                      *ngIf="
                        !(person | async).Id || f.EmploymentTypeId.value == employmentTypes.K1
                      ">
                      <input
                        type="radio"
                        id="radio-k1"
                        formControlName="EmploymentTypeId"
                        name="EmploymentTypeId"
                        [value]="employmentTypes.K1"
                        [attr.disabled]="(person | async).Id || disableK1 ? 'disabled' : null"
                        (change)="onEmploymentTypeChange()" />
                      <label
                        for="radio-k1"
                        title="A K-1 Partner is a partner/investor who is not paid a salary or wage for services. These individuals receive guaranteed payments or distributions against the company’s expected profits.  Partners cover their own employment taxes. The partnership will be responsible for preparing the Schedule K-1 form. It will not be produced by the payroll system."
                        ><span></span>K-1 Partner</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_identification_number_type'">
                <div class="col-sm-8">
                  <label>Identification Number Type</label>
                  <div class="radio-group flex-wrap justify-content-between">
                    <div>
                      <input
                        type="radio"
                        id="radio-ssn"
                        formControlName="UseEIN"
                        name="UseEIN"
                        value="0"
                        (change)="onUseEINChange()" />
                      <label for="radio-ssn"><span></span>Social Security Number</label>
                    </div>
                    &nbsp;
                    <div *ngIf="f.EmploymentTypeId.value == employmentTypes.M1099">
                      <input
                        type="radio"
                        id="radio-ein"
                        formControlName="UseEIN"
                        name="UseEIN"
                        value="1"
                        (change)="onUseEINChange()" />
                      <label for="radio-ein"><span></span>Federal Tax ID Number (EIN)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_identifier'">
                <div class="col-xl-8 col-lg-12" *ngIf="personHasFederalId | async">
                  <label *ngIf="f.UseEIN.value == '0'">Social Security Number</label>
                  <input
                    *ngIf="f.UseEIN.value == '0'"
                    class="form-control"
                    [disabled]="true"
                    value="*** - ** - {{ getFedIdLastFour | async }}" />
                  <label *ngIf="f.UseEIN.value == '1'">Federal Tax ID Number</label>
                  <input
                    *ngIf="f.UseEIN.value == '1'"
                    class="form-control"
                    [disabled]="true"
                    value="** - ***{{ getFedIdLastFour | async }}" />
                  <div class="input-validator">
                    <a class="green-link" (click)="clearFederalId()" *ngIf="!(readOnly | async)"
                      >clear</a
                    >
                  </div>
                </div>
                <div class="col-xl-8 col-lg-12" *ngIf="!(personHasFederalId | async)">
                  <label *ngIf="f.UseEIN.value == '0'">Social Security Number</label>
                  <label *ngIf="f.UseEIN.value == '1'">Federal Tax ID Number</label>
                  <!-- SSN -->
                  <input
                    *ngIf="f.UseEIN.value == '0' && (maskFederalId | async)"
                    formControlName="FederalIdentifier"
                    class="form-control"
                    mask="XXX - XX - XXXX"
                    [hiddenInput]="true" />
                  <!-- duplicate the control to resolve bug 5008. setting [hiddenInput]="maskFederalId" causes ux issues -->
                  <input
                    *ngIf="f.UseEIN.value == '0' && !(maskFederalId | async)"
                    appAutoFocus
                    formControlName="FederalIdentifier"
                    class="form-control"
                    mask="XXX - XX - XXXX"
                    placeholder="___ - __ - ____"
                    (blur)="federalIdBlur()" />
                  <!-- EIN -->
                  <input
                    *ngIf="f.UseEIN.value == '1' && (maskFederalId | async)"
                    formControlName="FederalIdentifier"
                    class="form-control"
                    mask="XX - XXXXXXX"
                    [hiddenInput]="true" />
                  <!-- duplicate the control to resolve bug 5008. setting [hiddenInput]="maskFederalId" causes ux issues -->
                  <input
                    *ngIf="f.UseEIN.value == '1' && !(maskFederalId | async)"
                    appAutoFocus
                    formControlName="FederalIdentifier"
                    class="form-control"
                    mask="XX - XXXXXXX"
                    placeholder="__ - _______"
                    (blur)="federalIdBlur()" />
                  <div *ngIf="f.FederalIdentifier.errors" class="input-error">
                    <span *ngIf="!f.FederalIdentifier.value; else invalidFedId">*required</span>
                    <ng-template #invalidFedId>
                      *invalid
                      <span *ngIf="f.UseEIN.value == '0'">Social Security Number</span>
                      <span *ngIf="f.UseEIN.value == '1'">Federal Tax ID Number</span>
                    </ng-template>
                  </div>
                  <!-- <div *ngIf="!f.FederalIdentifier.value && f.FederalIdentifier.errors?.required"
                       class="input-error">*required
                  </div> -->
                </div>
                <div class="col-xl-8 col-lg-12 hide-overflow">
                  <div class="slider" [ngClass]="!showFederalIdVerification ? 'closed' : ''">
                    <label
                      >Verify
                      <span *ngIf="f.UseEIN.value == '0'">Social Security Number</span>
                      <span *ngIf="f.UseEIN.value == '1'">Federal Tax ID Number</span>
                    </label>
                    <!-- SSN -->
                    <input
                      *ngIf="showFederalIdVerification && f.UseEIN.value == '0'"
                      formControlName="VerifyFederalIdentifier"
                      class="form-control"
                      type=""
                      mask="XXX - XX - XXXX"
                      [hiddenInput]="maskVerifyFederalId"
                      placeholder="___ - __ - ____" />
                    <!-- EIN -->
                    <input
                      *ngIf="showFederalIdVerification && f.UseEIN.value == '1'"
                      formControlName="VerifyFederalIdentifier"
                      class="form-control"
                      type=""
                      mask="XX - XXXXXXX"
                      [hiddenInput]="maskVerifyFederalId"
                      placeholder="__ - _______" />
                    <div *ngIf="f.VerifyFederalIdentifier.errors?.required" class="input-error">
                      *required
                    </div>
                    <div
                      *ngIf="
                        f.VerifyFederalIdentifier.errors?.mustMatch ||
                        f.VerifyFederalIdentifier.errors?.minlength
                      "
                      class="input-error">
                      *{{ f.UseEIN.value == '1' ? 'Federal Tax ID' : 'Social Security' }} Numbers
                      don't match
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_is_company'">
                <div
                  class="col-lg-8"
                  *ngIf="employmentTypes && f.EmploymentTypeId.value == employmentTypes.M1099">
                  <label>Use Company Name (optional)</label><br />
                  <input
                    formControlName="IsCompany"
                    type="checkbox"
                    id="iscompany-cb"
                    value="true"
                    (focusout)="updatePersonLabel()"
                    [attr.disabled]="
                      f.EmploymentTypeId.value == employmentTypes.K1 ? 'disabled' : null
                    " />
                  <label for="iscompany-cb"><span></span>Yes</label>
                </div>
              </div>
              <div class="row" *ngIf="!f.IsCompany.value">
                <div class="col-lg-8">
                  <div *hasPermission="'employee_first_name'">
                    <label>First Name</label>
                    <input
                      formControlName="FirstName"
                      class="form-control"
                      (focusout)="updatePersonLabel()" />
                    <div *ngIf="f.FirstName.errors?.required" class="input-error">*required</div>
                  </div>
                </div>
                <div class="col">
                  <div *hasPermission="'employee_middle_name'">
                    <label>Middle Name</label>
                    <input formControlName="MiddleName" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_last_name'">
                <div class="col-lg-12">
                  <label *ngIf="f.IsCompany.value">Company Name</label>
                  <label *ngIf="!f.IsCompany.value">Last Name</label>
                  <input
                    formControlName="LastName"
                    class="form-control"
                    (focusout)="updatePersonLabel()" />
                  <div *ngIf="f.LastName.errors?.required" class="input-error">*required</div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_birthday'">
                <div class="col-lg-12">
                  <label>Birthday</label>
                  <div class="input-group">
                    <input
                      formControlName="Birthday"
                      class="form-control datepicker"
                      ngbDatepicker
                      #d="ngbDatepicker"
                      [firstDayOfWeek]="7"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"
                      [placement]="['bottom-end', 'top-end']"
                      [maxDate]="today" />
                    <div *ngIf="!f.Birthday.valid" class="input-error input-group-error">
                      *invalid date
                    </div>
                    <img src="assets/icons/calendar.svg" (click)="d.toggle()" class="icon-append" />
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_personal_email_address'">
                <div class="col-lg-12">
                  <label>Personal Email Address</label>
                  <input formControlName="PersonalEmailAddress" class="form-control" type="email" />
                  <div *ngIf="f.PersonalEmailAddress.errors?.pattern" class="input-error">
                    *Must be in format name&#64;example.nn
                  </div>
                  <div *ngIf="f.PersonalEmailAddress.errors?.blacklistedDomain" class="input-error">
                    *{{ f.PersonalEmailAddress.errors?.blacklistedDomain }} is an invalid domain.
                    Please enter a different email address.
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div *hasPermission="'employee_home_phone_number'">
                    <label>Home Phone Number</label>
                    <input
                      formControlName="HomePhoneNumber"
                      class="form-control"
                      type="tel"
                      mask="(000) 000 - 0000"
                      placeholder="( ___ ) ___ - ____" />
                    <div *ngIf="f.HomePhoneNumber.errors" class="input-error">
                      *invalid phone number
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div *hasPermission="'employee_mobile_phone_number'">
                    <label>Mobile Phone Number</label>
                    <input
                      formControlName="MobilePhoneNumber"
                      class="form-control"
                      type="tel"
                      mask="(000) 000 - 0000"
                      placeholder="( ___ ) ___ - ____"
                      (ngModelChange)="validateMobilePhone()" />
                    <div
                      *ngIf="f.MobilePhoneNumber.value && f.MobilePhoneNumber.errors"
                      class="input-error">
                      *invalid
                      <span *ngIf="f.MobilePhoneNumber.value.length == 10">mobile&nbsp;</span>phone
                      number
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_gender'">
                <div class="col-lg-6">
                  <label>Gender</label>
                  <select formControlName="Gender" class="form-control">
                    <option></option>
                    <option *ngFor="let gender of genders" value="{{ gender.Id }}">
                      {{ gender.Value }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_marital_status'">
                <div class="col-lg-6">
                  <label>Marital Status (not filing status)</label>
                  <select formControlName="MaritalStatus" class="form-control">
                    <option></option>
                    <option *ngFor="let status of maritalStatuses" value="{{ status.Id }}">
                      {{ status.Value }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_race'">
                <div class="col-lg-6">
                  <label>Race</label>
                  <select formControlName="Race" class="form-control">
                    <option></option>
                    <option *ngFor="let race of races" value="{{ race.Id }}">
                      {{ race.Value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div
            class="card"
            *ngIf="authService.canRead('employee_address_panel')"
            [ngClass]="{ 'expanded-card': cardExpanders['address'] }">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('address')"
                title="Toggle tile expander">
                <i class="fas" [ngClass]="cardExpanders['address'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Address</h3>
              <div class="row" *hasPermission="'employee_non_us_address'">
                <div class="col-lg-12">
                  <fieldset
                    [disabled]="
                      (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                      (isEmployeePortal && !canSubmitRequests)
                    ">
                    <input
                      formControlName="IsNonUSAddress"
                      type="checkbox"
                      id="non-us-addr-cb"
                      value="true" />
                    <label for="non-us-addr-cb"
                      ><span></span>Non-US Address <small>(optional)</small></label
                    >
                  </fieldset>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_street_address'">
                <div class="col-lg-12">
                  <fieldset
                    [disabled]="
                      (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                      (isEmployeePortal && !canSubmitRequests)
                    ">
                    <label>Street Address</label>
                    <input
                      formControlName="StreetAddress"
                      class="form-control green-hover"
                      [class.input-green]="
                        activeAddressChangeRequestData != null &&
                        activeAddressChangeRequestData.New.StreetAddress != f.StreetAddress.value
                      "
                      maxlength="30" />
                  </fieldset>
                  <div
                    *ngIf="f.StreetAddress.errors?.required && f.StreetAddress.touched"
                    class="input-error">
                    *Please enter street address
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_street_address_2'">
                <div class="col-lg-12" *ngIf="!f.IsNonUSAddress.value">
                  <fieldset
                    [disabled]="
                      (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                      (isEmployeePortal && !canSubmitRequests)
                    ">
                    <label>Street Address (Line 2)</label>
                    <input
                      formControlName="StreetAddress2"
                      class="form-control green-hover"
                      [class.input-green]="
                        activeAddressChangeRequestData != null &&
                        activeAddressChangeRequestData.New.StreetAddress2 != f.StreetAddress2.value
                      "
                      maxlength="30" />
                  </fieldset>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_city'">
                <div class="col-lg-12">
                  <label>City</label>
                  <fieldset
                    [disabled]="
                      (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                      (isEmployeePortal && !canSubmitRequests)
                    ">
                    <input
                      formControlName="City"
                      class="form-control green-hover"
                      [class.input-green]="
                        activeAddressChangeRequestData != null &&
                        activeAddressChangeRequestData.New.City != f.City.value
                      "
                      maxlength="30" />
                  </fieldset>
                  <div *ngIf="f.City.errors?.required && f.City.touched" class="input-error">
                    *Please enter city
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-6">
                  <div *hasPermission="'employee_state'">
                    <fieldset
                      [disabled]="
                        (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                        (isEmployeePortal && !canSubmitRequests)
                      ">
                      <label *ngIf="!f.IsNonUSAddress.value">State</label>
                      <label *ngIf="f.IsNonUSAddress.value">State/Province/Region</label>
                      <select
                        *ngIf="!f.IsNonUSAddress.value"
                        formControlName="State"
                        class="form-control green-hover"
                        [class.input-green]="
                          activeAddressChangeRequestData != null &&
                          activeAddressChangeRequestData.New.State != f.State.value
                        ">
                        <option></option>
                        <option *ngFor="let state of states | async" value="{{ state.Id }}">
                          {{ state.Value }}
                        </option>
                      </select>
                      <input
                        *ngIf="f.IsNonUSAddress.value"
                        formControlName="State"
                        class="form-control green-hover"
                        [class.input-green]="
                          activeAddressChangeRequestData != null &&
                          activeAddressChangeRequestData.New.State != f.State.value
                        "
                        maxlength="30" />
                    </fieldset>
                    <div *ngIf="f.State.errors?.required && f.State.touched" class="input-error">
                      *Please enter state
                    </div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div *hasPermission="'employee_zip_code'">
                    <fieldset
                      [disabled]="
                        (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                        (isEmployeePortal && !canSubmitRequests)
                      ">
                      <label *ngIf="!f.IsNonUSAddress.value">Zip Code</label>
                      <label *ngIf="f.IsNonUSAddress.value">ZIP/Postal Code</label>
                      <input
                        *ngIf="!f.IsNonUSAddress.value"
                        formControlName="PostalCode"
                        class="form-control green-hover"
                        [class.input-green]="
                          activeAddressChangeRequestData != null &&
                          activeAddressChangeRequestData.New.PostalCode != f.PostalCode.value
                        "
                        mask="00000 - 0000"
                        [validation]="false"
                        (ngModelChange)="setZipCodeValidation()" />
                      <input
                        *ngIf="f.IsNonUSAddress.value"
                        formControlName="PostalCode"
                        class="form-control green-hover"
                        [class.input-green]="
                          activeAddressChangeRequestData != null &&
                          activeAddressChangeRequestData.New.PostalCode != f.PostalCode.value
                        "
                        maxlength="30" />
                    </fieldset>
                    <div *ngIf="f.PostalCode.touched">
                      <div *ngIf="f.PostalCode.errors?.required" class="input-error">
                        *Please enter zip code
                      </div>
                      <div *ngIf="f.PostalCode.errors?.minlength" class="input-error">
                        *invalid zip code
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_country'">
                <div class="col-lg-12" *ngIf="f.IsNonUSAddress.value">
                  <fieldset
                    [disabled]="
                      (hasActiveAddressChangeRequest && !isEmployeePortal) ||
                      (isEmployeePortal && !canSubmitRequests)
                    ">
                    <label>Country</label>
                    <input
                      formControlName="Country"
                      class="form-control green-hover"
                      [class.input-green]="
                        activeAddressChangeRequestData != null &&
                        activeAddressChangeRequestData.New.Country != f.Country.value
                      "
                      maxlength="30" />
                  </fieldset>
                </div>
              </div>
              <div
                class="row"
                *ngIf="!addressChanged && hasActiveAddressChangeRequest && canSubmitRequests">
                <div class="col-12">
                  <small class="text-cp-green" *ngIf="hasActiveAddressChangeRequest"
                    >*Changes pending approval</small
                  >
                </div>
              </div>
              <div class="row" *ngIf="canSubmitRequests">
                <div class="col-12">
                  <small *ngIf="addressChanged && isEmployeePortal"
                    >*Changes require approval</small
                  >
                </div>
                <div class="col-12 text-end" *ngIf="canSubmitRequests">
                  <button
                    class="btn me-3 btn-tertiary"
                    *ngIf="hasActiveAddressChangeRequest && !addressChanged"
                    (click)="viewPendingRequest()">
                    Review Change
                  </button>
                  <ng-container *ngIf="isEmployeePortal">
                    <button
                      class="btn btn-secondary me-3"
                      type="button"
                      *ngIf="addressChanged"
                      (click)="cancelAddressChange()">
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary"
                      (click)="submitAddressChangeRequest()"
                      *ngIf="addressChanged"
                      [disabled]="!addressValid"
                      type="button">
                      Submit
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['emergencyContacts'] }"
            *ngIf="authService.canRead('employee_emergency_contacts_panel')">
            <div class="card-body">
              <div class="float-end">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'people_edit_add_emergency_contact' }"
                  type="button"
                  class="btn btn-primary"
                  (click)="addEmergencyContact(contactModal)"
                  [disabled]="(readOnly | async) || !canEditEmergencyContacts">
                  <i class="fas fa-xs fa-plus"></i>&nbsp;Add Contact
                </button>
              </div>
              <a
                class="card-expander"
                (click)="toggleCardExpand('emergencyContacts')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['emergencyContacts'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Emergency Contacts</h3>
              <table *ngIf="(emergencyContacts | async).length > 0" class="table table-hover">
                <thead>
                  <tr>
                    <th>Full Name</th>
                    <th>Relationship</th>
                    <th>Phone Number</th>
                    <th>Primary</th>
                    <th style="width: 50px"></th>
                  </tr>
                </thead>
                <tbody *ngIf="emergencyContacts && (emergencyContacts | async).length > 0">
                  <tr *ngFor="let contact of emergencyContacts | async">
                    <td>{{ contact.FullName }}</td>
                    <td>{{ contact.Relationship }}</td>
                    <td>{{ contact.PhoneNumber | mask: '(000) 000-0000' }}</td>
                    <td>
                      <span *ngIf="contact.IsPrimary">
                        <img src="assets/icons/radio-selected.svg" />
                      </span>
                    </td>
                    <td>
                      <button
                        cpGTagEvent
                        [params]="{ event_label: 'people_edit_elete_emergency_contact' }"
                        *ngIf="!(readOnly | async) && canEditEmergencyContacts"
                        class="btn btn-link"
                        (click)="deleteEmergencyContact(contact)">
                        Delete
                      </button>
                      <span *ngIf="!(readOnly | async) && canEditEmergencyContacts"
                        >&nbsp;|&nbsp;</span
                      >
                      <button
                        cpGTagEvent
                        [params]="{ event_label: 'people_edit_edit_emergency_contact' }"
                        class="btn btn-link"
                        (click)="editEmergencyContact(contact, contactModal)">
                        {{ (readOnly | async) || !canEditEmergencyContacts ? 'View' : 'Edit' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <em *ngIf="(emergencyContacts | async).length === 0">No emergency contacts.</em>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <ng-template #contactModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Emergency Contact</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_emergency_contact_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form
        [formGroup]="emergencyContactForm"
        class="padded-form"
        [ngClass]="{ readOnly: (readOnly | async) }">
        <div class="row" *hasPermission="'employee_emergency_contacts_primary_contact'">
          <div class="col-lg-6" *ngIf="canMarkPrimaryEmergencyContact">
            <input formControlName="IsPrimary" type="checkbox" id="checkbox-primary" value="true" />
            <label for="checkbox-primary"><span></span>Primary Contact</label><br />
          </div>
        </div>
        <div class="row" *hasPermission="'employee_emergency_contacts_full_name'">
          <div class="col-lg-12">
            <label>Full Name</label>
            <input appAutoFocus formControlName="FullName" class="form-control" />
            <div *ngIf="e.FullName.errors?.required" class="input-error">*required</div>
          </div>
        </div>
        <div class="row" *hasPermission="'employee_emergency_contacts_relationship'">
          <div class="col-lg-12">
            <label>Relationship</label>
            <input formControlName="Relationship" class="form-control" />
          </div>
        </div>
        <div class="row" *hasPermission="'employee_emergency_contacts_phone_number'">
          <div class="col-lg-12">
            <label>Phone Number</label>
            <input
              formControlName="PhoneNumber"
              class="form-control"
              type="tel"
              mask="(000) 000 - 0000"
              placeholder="( ___ ) ___ - ____" />
            <div *ngIf="e.PhoneNumber.errors?.required" class="input-error">*required</div>
            <div
              *ngIf="!e.PhoneNumber.errors?.required && e.PhoneNumber.errors"
              class="input-error">
              *invalid phone number
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'people_edit_emergency_contact_modal_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_emergency_contact_modal_save' }"
        [disabled]="!emergencyContactForm.valid || (readOnly | async) || !canEditEmergencyContacts">
        Save Contact
      </button>
    </div>
    <div class="text-end pb-2 pe-3" *ngIf="readOnly | async">
      <strong
        ><em>{{ clientLockMsg }}</em></strong
      >
    </div>
  </ng-template>
  <lib-address-change-review-modal
    *ngIf="activeAddressChangeRequest != null && isEmployeePortal"
    [addressChangeRequestData]="activeAddressChangeRequestData"
    [changeRequest]="activeAddressChangeRequest"
    (modalClosed)="closeModal($event)">
  </lib-address-change-review-modal>
  <lib-address-change-modal
    *ngIf="activeAddressChangeRequest != null && !isEmployeePortal"
    [addressChangeRequestData]="activeAddressChangeRequestData"
    [changeRequest]="activeAddressChangeRequest"
    (modalClosed)="closeModal($event)"></lib-address-change-modal>
}
